import { create } from 'zustand';

export type GuestQuoteClaimNoticeKind =
  | 'CUSTOMER_ONLY'
  | 'ALREADY_CLAIMED'
  | 'NOT_FOUND'
  | 'FAILED';

export interface GuestQuoteClaimNoticeMessage {
  readonly kind: GuestQuoteClaimNoticeKind;
  readonly message: string;
}

/**
 * 연결 결과 안내 문구(결정 G10). 관리자 계정(GUEST_QUOTE_CLAIM_CUSTOMER_ONLY)·이미 다른 계정에 연결됨(GUEST_QUOTE_ALREADY_CLAIMED)은
 * 서버 문구가 먼저고, 비었을 때만 이 문구다. 연락처 일치는 더 이상 조건이 아니다(링크를 가진 고객 계정 누구나).
 */
export const GUEST_QUOTE_CLAIM_MESSAGES = {
  CUSTOMER_ONLY: '고객 계정으로 로그인해 주세요.',
  ALREADY_CLAIMED: '이미 다른 계정에 연결된 견적이에요.',
  NOT_FOUND: '연결할 견적을 찾을 수 없어요. 받은 견적 링크를 다시 확인해 주세요.',
  FAILED: '견적을 계정에 연결하지 못했어요. 잠시 후 다시 시도해 주세요.',
} as const;

interface GuestQuoteClaimNoticeState {
  readonly notice: GuestQuoteClaimNoticeMessage | null;
  readonly show: (notice: GuestQuoteClaimNoticeMessage) => void;
  readonly dismiss: () => void;
}

/**
 * 견적 연결 결과 안내. 연결은 앱 셸 훅이나 링크 화면 [주문하기]에서 일어나고, 안내는 앱 셸이 한곳에 띄운다.
 * 그래서 화면을 옮겨도 안내가 남는다. 서버 상태가 아닌 화면 알림이라 저장하지 않는다.
 */
export const useGuestQuoteClaimNoticeStore = create<GuestQuoteClaimNoticeState>()((set) => ({
  notice: null,
  show: (notice) => set({ notice }),
  dismiss: () => set({ notice: null }),
}));
